/**
 * Wahler-Backend
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ImportanceScale {

    PARAMOUNT_IMPORTANCE = 'PARAMOUNT_IMPORTANCE',

    VERY_VERY_STRONG_IMPORTANCE = 'VERY_VERY_STRONG_IMPORTANCE',

    VERY_STRONG_OR_PROVEN_IMPORTANCE = 'VERY_STRONG_OR_PROVEN_IMPORTANCE',

    STRONG_TO_VERY_STRONG_IMPORTANCE = 'STRONG_TO_VERY_STRONG_IMPORTANCE',

    STRONG_IMPORTANCE = 'STRONG_IMPORTANCE',

    MODERATE_IMPORTANCE = 'MODERATE_IMPORTANCE',

    A_LITTLE_MORE_IMPORTANCE = 'A_LITTLE_MORE_IMPORTANCE',

    LIGHT_OR_WEAK_IMPORTANCE = 'LIGHT_OR_WEAK_IMPORTANCE',

    EQUAL_IMPORTANCE = 'EQUAL_IMPORTANCE',

    SLIGHTLY_LESS_IMPORTANCE = 'SLIGHTLY_LESS_IMPORTANCE',

    MODERATELY_LESS_IMPORTANCE = 'MODERATELY_LESS_IMPORTANCE',

    MUCH_LESS_IMPORTANCE = 'MUCH_LESS_IMPORTANCE',

    STRONG_TO_VERY_STRONG_LESS_IMPORTANCE = 'STRONG_TO_VERY_STRONG_LESS_IMPORTANCE',

    VERY_MUCH_LESS_IMPORTANCE = 'VERY_MUCH_LESS_IMPORTANCE',

    EXTREMELY_LESS_IMPORTANCE = 'EXTREMELY_LESS_IMPORTANCE',

    LEAST_IMPORTANCE = 'LEAST_IMPORTANCE',

    ABSOLUTE_UNIMPORTANCE = 'ABSOLUTE_UNIMPORTANCE'
}

